export default __webpack_public_path__ + "static/media/mail.43b97bbc.png";